<div class="dialog" *ngIf="dynamicFormFields">
  <div mat-dialog-title class="dialogHeader">
    <div class="headertitle">⚠️Changing Your Email Will Affect Your Access</div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="content" >

   <div>
        <span>Changing your MCT email will remove access to:</span>
        <ul>
            <li>Visual Studio</li>
            <li>Azure tenants</li>
            <li>M365 apps (Exchange, SharePoint, Teams, and OneDrive)</li>
        </ul>
   </div>

    <div>
        You'll need to  recreate accounts for  Azure tenants and Microsoft 365 applications using your new email. A new account for Visual Studio will be created for you.
    </div>

    <div>
        <strong>We cannot recover any data from your previous account after the change.</strong>
    </div>

  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="footer">
    <button mat-flat-button class="flat-button" (click)="cancelClicked()">Cancel</button>
    <button mat-flat-button class="flat-button" (click)="continueClicked()">Continue</button>
  </div>
</div>